import { makeStyles } from '@material-ui/core'

import { getDirection } from '../../../localization'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    marginRight: -96,
    marginLeft: -96,
    marginTop: -20,
    [theme.breakpoints.down('sm')]: {
      marginRight: -15,
      marginLeft: -15
    }
  },
  tabPanel: {
    paddingRight: 72,
    paddingLeft: 72,
    paddingTop: 24,
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
      paddingLeft: 0
    }
  },
  tab: {
    fontSize: 14,
    minWidth: 0,
    '&.Mui-selected': {
      border: `3px solid ${theme.palette.primary.main}`,
      borderTop: 'none'
    },
    flex: 1,
    textAlign: 'center'
  },
  topBar: {
    height: 48,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 16,
    paddingRight: 16,
    boxShadow: 'none',
    borderBottom: '1px solid #dbdbdb',
    [theme.breakpoints.down('sm')]: { paddingLeft: 0 }
  },
  tabs: {
    [theme.breakpoints.down('sm')]: { paddingLeft: 0 },
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  backIcon: {
    transform: `rotate(${getDirection() === 'rtl' ? '180deg' : '0deg'})`
  }
}))

export default useStyles
